import chroma from 'chroma-js';

export const getDiscreteGradientColor = (
  startColor: string,
  endColor: string,
  numSteps: number,
  value: number
): string => {
  return chroma
    .scale([startColor, endColor])(value / numSteps)
    .hex();
};
